export const TOTAL_FRAMES = Number(process.env.TOTAL_FRAMES ?? 50);
